import { tr } from 'date-fns/locale';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  userManagementData: {
    userManagementData: [],
    count: "",
    isLoading: false,
    isError: false
  },
  userManagementDetails: [{}],
  deletedUser: {},
  deleteUserManagement: {},
  bunitFilterList: {},
  bunitFilterCommonList: {},
  createdUserMgtData: {},
  triggerMailData:{},
  updatedUserMgtData: {},
  isLoading: false,
  isError: false,
  rolesLov: [],
  userProfile: {
    isLoading: null
  },
  forgotPasswordResetDetails:{},
  passwordResetDetails: {},
  tokenAuthDetails: {},
  adminDetails: {},
  updatedAdminDetails: {}
}

const userReducer = (state = initialState, action = {}) => {

  const newState = { ...state };

  switch (action.type) {
    case actionTypes.FETCH_USER_MGT_DETAILS:
      return { ...newState, isLoading: true };

    case actionTypes.FETCH_USER_MGT_DETAILS_SUCCESS:
      return { ...newState, isLoading: false, userManagementDetails: { ...action.payload } };

    case actionTypes.FETCH_USER_MGT_DETAILS_FAILURE:
      return { ...newState, isLoading: false, userManagementDetails: { ...newState.userManagementDetails }, isError: true };

    case actionTypes.FETCH_USER_MGT_LIST:
      return { ...newState, userManagementData: { ...newState.userManagementData, isLoading: true } };

    case actionTypes.FETCH_USER_MGT_LIST_SUCCESS:
      return { ...newState, userManagementData: { userManagementData: [...action.payload.data], count: action.payload.totalCount, isLoading: false, isError: false }, createdUserMgtData: {}, updatedUserMgtData: {},deletedUser: {}, isError: false };

    case actionTypes.FETCH_USER_MGT_LIST_FAILURE:
      return { ...newState, userManagementData: { userManagementData: {...action.payload} , count: action.payload.totalCount, isLoading: false, isError: true } };

    case actionTypes.FETCH_USER_MGT_FILTER_LIST:
      return { ...newState, isLoading: true };

    case actionTypes.FETCH_USER_MGT_FILTER_LIST_SUCCESS:
      return { ...newState, isLoading: false, bunitFilterList: { ...action.payload } };

    case actionTypes.FETCH_USER_MGT_FILTER_LIST_FAILURE:
      return { ...newState, isLoading: false, isError: true, bunitFilterList: { ...action.payload } };

      case actionTypes.FETCH_SELF_REG_FILTER_LIST:
      return { ...newState, isLoading: true };

    case actionTypes.FETCH_SELF_REG_FILTER_LIST_SUCCESS:
      return { ...newState, isLoading: false, bunitFilterCommonList: { ...action.payload } };

    case actionTypes.FETCH_SELF_REG_FILTER_LIST_FAILURE:
      return { ...newState, isLoading: false, isError: true, bunitFilterCommonList: { ...action.payload } };


    case actionTypes.CREATE_USER_MGT:
      return { ...newState, isLoading: true };

    case actionTypes.CREATE_USER_MGT_SUCCESS:
      return { ...newState, isLoading: false, createdUserMgtData: { ...action.payload } };

    case actionTypes.CREATE_USER_MGT_FAILURE:
      return { ...newState, isLoading: false, isError: true , createdUserMgtData: { ...action.payload }};

    case actionTypes.UPDATE_USER_MGT:
    return { ...newState, isLoading: true };

    case actionTypes.UPDATE_USER_MGT_SUCCESS:
      return { ...newState, isLoading: false, updatedUserMgtData: { ...action.payload } };

    case actionTypes.UPDATE_USER_MGT_FAILURE:
      return { ...newState, isLoading: false, isError: true, updatedUserMgtData: { ...action.payload } };

    case actionTypes.DELETE_USER_MGT:
        return {...newState , isLoading: true, deletedUser:{}};
          
    case actionTypes.DELETE_USER_MGT_SUCCESS:
        return {...newState , isLoading: false, isError:false, deletedUser:{...action.payload}, errorMessage: {}};
  
    case actionTypes.DELETE_USER_MGT_FAILURE:
        return {...newState , isLoading: false, isError:true, errorMessage: {...action.payload}, deleteUser: {} };

    case actionTypes.FETCH_ROLES_LOV_SUCCESS: 
        return {...newState , isLoading: false, rolesLov: {...action.payload}};

    case actionTypes.FETCH_ROLES_LOV_FAILURE:
      return { ...newState, isLoading: false, isError: true, rolesLov:{...action.payload} };

    case actionTypes.GET_USER_MGT:
        return { ...newState,  userProfile:{...action.userProfile, isLoading: true} };

    case actionTypes.GET_USER_MGT_SUCCESS:
        return {...newState , isLoading: false, isError:false, userProfile:{...action.payload, isLoading: false}};

    case actionTypes.GET_USER_MGT_FAILURE:
        return { ...newState, isLoading: false, isError: true, userProfile:{...action.payload, isLoading: false} };
    
    case actionTypes.RESET_USER_PROFILE:
          return {...initialState};

    case actionTypes.RESET_MY_FORGOT_PWD_SUCCESS:
        return {...newState , isLoading: false, isError:false, forgotPasswordResetDetails:{...action.payload}};

    case actionTypes.RESET_MY_FORGOT_PWD_FAILURE:
        return { ...newState, isLoading: false, isError: true, forgotPasswordResetDetails:{...action.payload} };

    case actionTypes.RESET_MY_PWD_SUCCESS:
          return {...newState , isLoading: false, isError:false, passwordResetDetails:{...action.payload}};
  
    case actionTypes.RESET_MY_PWD_FAILURE:
          return { ...newState, isLoading: false, isError: true, passwordResetDetails:{...action.payload} };
        
    case actionTypes.TOKEN_AUTH_SUCCESS:
            return {...newState , isLoading: false, isError:false, tokenAuthDetails:{...action.payload}};
    
    case actionTypes.TOKEN_AUTH_FAILURE:
            return { ...newState, isLoading: false, isError: true, tokenAuthDetails:{...action.payload} };

    case actionTypes.GET_ADMIN_DETAILS:
      return { ...newState, isLoading: true };

    case actionTypes.GET_ADMIN_DETAILS_SUCCESS:
      return { ...newState, isLoading: false, adminDetails: { ...action.payload } };

    case actionTypes.GET_ADMIN_DETAILS_FAILURE:
      return { ...newState, isLoading: false, isError: true, adminDetails: { ...action.payload } };

    case actionTypes.RESET_PROFILE:
      return  { ...newState, isLoading: false, updatedUserMgtData: {} };  

    case actionTypes.UPDATE_ADMIN_DETAILS:
      return { ...newState, isLoading: true };

    case actionTypes.UPDATE_ADMIN_DETAILS_SUCCESS:
      return { ...newState, isLoading: false, updatedAdminDetails: { ...action.payload } };

    case actionTypes.UPDATE_ADMIN_DETAILS_FAILURE:
      return { ...newState, isLoading: false, isError: true, updatedAdminDetails: { ...action.payload } };
          
    // case actionTypes.GET_USER_MGT_FAILURE:
    //     return {...newState , isLoading: false, isError:true };
    
    case actionTypes.TRIGGER_MAIL:
      return { ...newState, isLoading: true };

    case actionTypes.TRIGGER_MAIL_SUCCESS:
      return { ...newState, isLoading: false, triggerMailData: { ...action.payload } };

    case actionTypes.TRIGGER_MAIL_FAILURE:
      return { ...newState, isLoading: false, isError: true , triggerMailData: { ...action.payload }};

    default:
      return { ...newState };
  }
};


export default userReducer;